import { useContext, useEffect, useState } from "react";
import useGet from "../hooks/useGet";
import BlogArticlePreview from "../components/blog/BlogArticlePreview";
import Button from "../components/ui/Button";
import Loading from "../components/ui/Loading";
import SEO from "../components/shared/SEO";
import NewsletterForm from "../components/shared/NewsletterForm";
import poweredByContext from "../store/PoweredByContext";
import LazyLoadingContext from "../store/LazyLoadingContext";
import { getUrl } from "../utilities/url";
import QuoteQueryJets from "../components/shared/QuoteQueryJets";
import getClassName from "../utilities/getClassName";

const Blog = () => {
    const perPage = 12;
    const [articlesList, setArticlesList] = useState([]);
    const [loadingMore, setLoadingMore] = useState(false);
    const [page, setPage] = useState(0);
    const [firstArticle, setFirstArticle] = useState(0);
    const { returnData: articles } = useGet(`/api/content/blog?page=${page}&pageSize=${perPage}`);

    const poweredByCtx = useContext(poweredByContext);
    const lazyLoadingCtx = useContext(LazyLoadingContext);

    useEffect(() => {
        if (articles !== false && articles !== "") {
            lazyLoadingCtx.updatePageCheck("blog", {
                blog: true,
            });
        }
    }, [articles, lazyLoadingCtx]);

    useEffect(() => {
        document.documentElement.style.scrollSnapType = "none";

        return () => {
            lazyLoadingCtx.reset("blog");
        };
        // Intentionally mount-only: re-firing would call reset() and clobber
        // page-ready state that other effects have already populated.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (articles) {
            if (articles.results[0]) {
                setFirstArticle(articles.results[0].id);
                // Functional update so we don't have to depend on articlesList,
                // which would re-fire this effect every time we updated it.
                setArticlesList((prev) => prev.concat(articles.results));
            }
        }
    }, [articles]);

    useEffect(() => {
        setLoadingMore(false);
    }, [articlesList]);

    const loadMore = () => {
        setLoadingMore(true);
        setPage(page + 1);
    };

    return (
        <>
            <SEO
                title={articles.metaTitle}
                description={articles.metaDescription}
                canonicalUrl={getUrl(poweredByCtx, window.location.pathname)}
            />

            {(!lazyLoadingCtx.pageReady || articles?.stickyQuoteBool) && (
                <div className="wrap">
                    <QuoteQueryJets onPage skeleton={!lazyLoadingCtx.pageReady} />
                </div>
            )}

            <div className={getClassName(["blog", lazyLoadingCtx.pageReady && articles ? "" : "blog--skeleton"])}>
                <div className="wrap">
                    <header className="blog__header">
                        <h1>SHY Aviation Blog</h1>
                    </header>

                    {lazyLoadingCtx.pageReady && articles ? (
                        <>
                            <div className="blog__list">
                                {articlesList.map((article, i) => {
                                    return (
                                        <BlogArticlePreview
                                            data={article}
                                            key={article.id}
                                            scrollToArticle={article.id === firstArticle && page !== 0}
                                        />
                                    );
                                })}
                            </div>
                            <div className="blog__footer">
                                {loadingMore ? (
                                    <Loading />
                                ) : page < articles.totalPages - 1 ? (
                                    <Button
                                        onClick={loadMore}
                                        classNames={["button--full", "button--tertiary"]}
                                        animate={true}
                                    >
                                        Load more
                                    </Button>
                                ) : null}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="blog__list">
                                <BlogArticlePreview
                                    data={{
                                        articleDate: "2022-06-15T00:00:00Z",
                                        title: "skeleton",
                                        abstract: "skeleton",
                                    }}
                                    skeleton={true}
                                />
                                <BlogArticlePreview
                                    data={{
                                        articleDate: "2022-06-15T00:00:00Z",
                                        title: "skeleton",
                                        abstract: "skeleton",
                                    }}
                                    skeleton={true}
                                />
                                <BlogArticlePreview
                                    data={{
                                        articleDate: "2022-06-15T00:00:00Z",
                                        title: "skeleton",
                                        abstract: "skeleton",
                                    }}
                                    skeleton={true}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>

            <NewsletterForm />
        </>
    );
};

export default Blog;
